import { ConversationCloseIconButton } from "@circle-react-shared/AiConversation/header/ConversationCloseIconButton";
import { useIsCommunityAdmin } from "@circle-react/contexts/punditUserContext";
import { useShallow } from "zustand/react/shallow";

import { t } from "@/i18n-js/instance";
import { useIsCircleAiPageRoute } from "@/react/components/CircleAi/useIsCircleAiPageRoute";
import { useIsAdminArea } from "@/react/components/SettingsApp/CompassCompat/useIsAdminArea";

import { DOM_IDS } from "./Layout/defaults";
import { useCircleAIShellStore } from "./store/circleAIShellStore";

export const ConversationPanelCloseButton = () => {
  const isAdmin = useIsCommunityAdmin();
  const isAdminArea = useIsAdminArea();
  const { isAiRoute } = useIsCircleAiPageRoute();

  const { setConversationPanelState, setAdminDockForced, setMode } =
    useCircleAIShellStore(
      useShallow(s => ({
        setConversationPanelState: s.setConversationPanelState,
        setAdminDockForced: s.setAdminDockForced,
        setMode: s.setMode,
      })),
    );

  const handleClick = () => {
    setConversationPanelState("closed");
    if (isAdmin) {
      setAdminDockForced(false);
      if (!isAdminArea && !isAiRoute) setMode("community");
    }
  };

  return (
    <ConversationCloseIconButton
      data-testid="circle-ai-shell-conversation-panel-close"
      onClose={handleClick}
      icon="arrow-wall-left"
      label={t("circle_ai_shell.close_ai_canvas")}
      aria-controls={DOM_IDS.conversationPanelBody}
    />
  );
};

ConversationPanelCloseButton.displayName =
  "CircleAIAppShell.ConversationPanelCloseButton";
